import { Excess } from 'scenes/common/types';
import { WireCoverageRefId, WireExcess, WireExcessType } from '../types';

export const toWireExcesses = (
  buildingExcess: Excess,
  contentsExcess: Excess
): WireExcess[] =>
  [buildingExcess, contentsExcess]
    .filter((excess) => excess?.id)
    .map((excess) => ({
      id: excess.id,
      name: excess.name,
      type: excess.type as WireExcessType,
      amount: excess.amount,
    }));

export const toExcess = (excess: WireExcess): Excess => ({
  id: excess.id,
  code: excess.code,
  amount: excess.amount,
  type: excess.type,
  name: excess.name,
});

export const filterByRefId = (id: string): boolean =>
  (Object.values(WireCoverageRefId) as string[]).some((refId) =>
    id.toLowerCase().includes(`${refId.toLowerCase()}-`)
  );
